import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import PageTitle2 from "../../components/pagetitle/PageTitle2";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import RetailBusiness from "../../components/WorkWithTCUK/RetailBusiness";
import RetailAgent from "../../components/WorkWithTCUK/RetailAgent";
import {
  FaLink,
  FaArrowRight,
  FaCopy,
  FaSearch,
  FaTimes,
  FaEye,
  FaEyeSlash,
  FaChevronDown,
  FaMapMarkerAlt,
  FaUsers as FaUsersIcon,
  FaGlobe,
} from "react-icons/fa";
import { IoArrowForward, IoArrowBack } from "react-icons/io5";
import { API_URL } from "../../constant";
import { useLocation } from "react-router-dom";
import { debounce } from "lodash";
import QRCode from "react-qr-code";

// Region options for countries
const regionOptions = {
  // Africa
  Afghanistan: ["Asia"],  
  Albania: ["Europe"],
  Algeria: ["Africa"],
  Andorra: ["Europe"],
  Angola: ["Africa"],
  Argentina: ["South America"],
  Armenia: ["Asia"],
  Australia: ["Oceania"],
  Austria: ["Europe"],
  Azerbaijan: ["Asia"],
  Bahamas: ["North America"],
  Bahrain: ["Asia"],
  Bangladesh: ["Asia"],
  Barbados: ["North America"],
  Belarus: ["Europe"],
  Belgium: ["Europe"],
  Belize: ["North America"],
  Benin: ["Africa"],
  Bhutan: ["Asia"],
  Bolivia: ["South America"],
  "Bosnia and Herzegovina": ["Europe"],
  Botswana: ["Africa"],
  Brazil: ["South America"],
  Brunei: ["Asia"],
  Bulgaria: ["Europe"],
  "Burkina Faso": ["Africa"],
  Burundi: ["Africa"],
  Cambodia: ["Asia"],
  Cameroon: ["Africa"],
  Canada: ["Alberta", "British Columbia", "Manitoba", "Ontario", "Quebec"],
  "Cape Verde": ["Africa"],
  "Central African Republic": ["Africa"],
  Chad: ["Africa"],
  Chile: ["South America"],
  China: ["Asia"],
  Colombia: ["South America"],
  Comoros: ["Africa"],
  Congo: ["Africa"],
  "Costa Rica": ["North America"],
  Croatia: ["Europe"],
  Cuba: ["North America"],
  Cyprus: ["Europe"],
  "Czech Republic": ["Europe"],
  Denmark: ["Europe"],
  Djibouti: ["Africa"],
  "Dominican Republic": ["North America"],
  Ecuador: ["South America"],
  Egypt: ["Africa"],
  "El Salvador": ["North America"],
  Estonia: ["Europe"],
  Ethiopia: ["Africa"],
  Finland: ["Europe"],
  France: ["Europe"],
  Germany: ["Europe"],
  Ghana: ["Africa"],
  Greece: ["Europe"],
  Guatemala: ["North America"],
  Haiti: ["North America"],
  Honduras: ["North America"],
  Hungary: ["Europe"],
  Iceland: ["Europe"],
  India: [
    "Andhra Pradesh",
    "Delhi",
    "Karnataka",
    "Maharashtra",
    "Tamil Nadu",
    "West Bengal",
  ],
  Indonesia: ["Asia"],
  Iran: ["Tehran", "Isfahan", "Fars", "Mazandaran", "Khorasan Razavi"],
  Iraq: ["Asia"],
  Ireland: ["Europe"],
  Israel: ["Asia"],
  Italy: ["Europe"],
  Jamaica: ["North America"],
  Japan: ["Asia"],
  Jordan: ["Asia"],
  Kazakhstan: ["Asia"],
  Kenya: ["Africa"],
  Kuwait: ["Asia"],
  Kyrgyzstan: ["Asia"],
  Laos: ["Asia"],
  Latvia: ["Europe"],
  Lebanon: ["Asia"],
  Lesotho: ["Africa"],
  Liberia: ["Africa"],
  Libya: ["Africa"],
  Lithuania: ["Europe"],
  Luxembourg: ["Europe"],
  Madagascar: ["Africa"],
  Malawi: ["Africa"],
  Malaysia: ["Asia"],
  Maldives: ["Asia"],
  Mali: ["Africa"],
  Malta: ["Europe"],
  Mexico: ["North America"],
  Moldova: ["Europe"],
  Mongolia: ["Asia"],
  Morocco: ["Africa"],
  Mozambique: ["Africa"],
  Myanmar: ["Asia"],
  Namibia: ["Africa"],
  Nepal: ["Asia"],
  Netherlands: ["Europe"],
  "New Zealand": ["Oceania"],
  Nicaragua: ["North America"],
  Niger: ["Africa"],
  Nigeria: ["Africa"],
  "North Korea": ["Asia"],
  Norway: ["Europe"],
  Oman: ["Asia"],
  Pakistan: ["Asia"],
  Panama: ["North America"],
  Paraguay: ["South America"],
  Peru: ["South America"],
  Philippines: ["Asia"],
  Poland: ["Europe"],
  Portugal: ["Europe"],
  Qatar: ["Asia"],
  Romania: ["Europe"],
  Russia: ["Europe"],
  Rwanda: ["Africa"],
  "Saudi Arabia": ["Asia"],
  Senegal: ["Africa"],
  Serbia: ["Europe"],
  Singapore: ["Asia"],
  Slovakia: ["Europe"],
  Slovenia: ["Europe"],
  Somalia: ["Africa"],
  "South Africa": ["Africa"],
  "South Korea": ["Asia"],
  Spain: ["Europe"],
  "Sri Lanka": [
    "Central Province",
    "Eastern Province",
    "Northern Province",
    "Southern Province",
    "Western Province",
    "North Central Province",
    "North Western Province",
    "Sabaragamuwa Province",
    "Uva Province",
  ],
  Sudan: ["Africa"],
  Sweden: ["Europe"],
  Switzerland: ["Europe"],
  Syria: ["Asia"],
  Taiwan: ["Asia"],
  Tanzania: ["Africa"],
  Thailand: ["Asia"],
  Tunisia: ["Africa"],
  Turkey: ["Asia"],
  Uganda: ["Africa"],
  Ukraine: ["Europe"],
  "United Arab Emirates": ["Asia"],
  "United Kingdom": [
    "England - Bedfordshire",
    "England - Berkshire",
    "England - Bristol",
    "England - Buckinghamshire",
    "England - Cambridgeshire",
    "England - Cheshire",
    "England - City of London",
    "England - Cornwall",
    "England - Cumbria",
    "England - Derbyshire",
    "England - Devon",
    "England - Dorset",
    "England - Durham",
    "England - East Riding of Yorkshire",
    "England - East Sussex",
    "England - Essex",
    "England - Gloucestershire",
    "England - Greater London",
    "England - Greater Manchester",
    "England - Hampshire",
    "England - Herefordshire",
    "England - Hertfordshire",
    "England - Isle of Wight",
    "England - Kent",
    "England - Lancashire",
    "England - Leicestershire",
    "England - Lincolnshire",
    "England - Merseyside",
    "England - Norfolk",
    "England - North Yorkshire",
    "England - Northamptonshire",
    "England - Northumberland",
    "England - Nottinghamshire",
    "England - Oxfordshire",
    "England - Rutland",
    "England - Shropshire",
    "England - Somerset",
    "England - South Yorkshire",
    "England - Staffordshire",
    "England - Suffolk",
    "England - Surrey",
    "England - Sussex",
    "England - Tyne & Wear",
    "England - Warwickshire",
    "England - West Midlands",
    "England - West Sussex",
    "England - West Yorkshire",
    "England - Wiltshire",
    "England - Worcestershire",
    "Northern Ireland - Antrim",
    "Northern Ireland - Armagh",
    "Northern Ireland - Down",
    "Northern Ireland - Fermanagh",
    "Northern Ireland - Londonderry",
    "Northern Ireland - Tyrone",
    "Scotland - City of Aberdeen",
    "Scotland - Aberdeenshire",
    "Scotland - Angus",
    "Scotland - Argyll",
    "Scotland - Ayrshire",
    "Scotland - Banffshire",
    "Scotland - Berwickshire",
    "Scotland - Bute",
    "Scotland - Caithness",
    "Scotland - Clackmannanshire",
    "Scotland - Dumfriesshire",
    "Scotland - Dunbartonshire",
    "Scotland - City of Dundee",
    "Scotland - East Lothian",
    "Scotland - City of Edinburgh",
    "Scotland - Fife",
    "Scotland - City of Glasgow",
    "Scotland - Inverness-shire",
    "Scotland - Kincardineshire",
    "Scotland - Kinross-shire",
    "Scotland - Kirkcudbrightshire",
    "Scotland - Lanarkshire",
    "Scotland - Midlothian",
    "Scotland - Moray",
    "Scotland - Nairnshire",
    "Scotland - Orkney",
    "Scotland - Peeblesshire",
    "Scotland - Perthshire",
    "Scotland - Renfrewshire",
    "Scotland - Ross and Cromarty",
    "Scotland - Roxburghshire",
    "Scotland - Selkirkshire",
    "Scotland - Shetland",
    "Scotland - Stirlingshire",
    "Scotland - Sutherland",
    "Scotland - West Lothian",
    "Scotland - Wigtownshire",
    "Wales - Blaenau Gwent",
    "Wales - Bridgend",
    "Wales - Caerphilly",
    "Wales - Carmarthenshire",
    "Wales - Ceredigion",
    "Wales - Swansea",
    "Wales - Cardiff",
    "Wales - Conwy",
    "Wales - Denbighshire",
    "Wales - Flintshire",
    "Wales - Gwynedd",
    "Wales - Isle of Anglesey",
    "Wales - Merthyr Tydfil",
    "Wales - Monmouthshire",
    "Wales - Neath Port Talbot",
    "Wales - Newport",
    "Wales - Pembrokeshire",
    "Wales - Powys",
    "Wales - Rhondda Cynon Taf",
    "Wales - Torfaen",
    "Wales - Vale of Glamorgan",
    "Wales - Wrexham",
  ],
  "United States": ["North America"],
  Uruguay: ["South America"],
  Uzbekistan: ["Asia"],
  Venezuela: ["South America"],
  Vietnam: ["Asia"],
  Yemen: ["Asia"],
  Zambia: ["Africa"],
  Zimbabwe: ["Africa"],
};

// Agents Section Component
const AgentsSection = ({
  searchQuery,
  setSearchQuery,
  selectedCountry,
  setSelectedCountry,
  selectedRegion,
  setSelectedRegion,
  selectedTown,
  setSelectedTown,
  selectedAdminArea,
  setSelectedAdminArea,
  availableCountries,
  availableRegions,
  availableTowns,
  availableAdminAreas,
  filteredAgents,
  isLoadingAgents,
  agentsError,
  searchError,
  fetchSeniorAgentsWithFilters,
  handleFilterChange,
  currentPage,
  totalPages,
  handlePageChange,
  debouncedFetchAgents,
  setCurrentPage,
  selectedUserType,
  handleUserTypeChange,
  handleCardClick,
  getAgentReferralLink,
}) => {
  const agentsListRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const [isRegionDropdownOpen, setIsRegionDropdownOpen] = useState(false);
  const [selectedAgentQr, setSelectedAgentQr] = useState(null);

  // Country list
  const countries = Object.keys(regionOptions);

  // Set default values
  const defaultCountry = "United Kingdom";
  const defaultRegion = "England - City of London";

  // Initialize with default values if not provided
  useEffect(() => {
    if (!selectedCountry) {
      setSelectedCountry(defaultCountry);
    }
    if (!selectedRegion) {
      setSelectedRegion(defaultRegion);
    }
  }, []);

  // Handle country change
  const handleCountryChange = (country) => {
    setSelectedCountry(country);
    // Reset region to first available or default for UK
    if (country === "United Kingdom") {
      setSelectedRegion(defaultRegion);
    } else {
      const regions = regionOptions[country] || [];
      setSelectedRegion(regions[0] || "");
    }
    setIsCountryDropdownOpen(false);
  };

  // Handle region change
  const handleRegionChange = (region) => {
    setSelectedRegion(region);
    setIsRegionDropdownOpen(false);
  };

  // Get current regions based on selected country
  const currentRegions = selectedCountry
    ? regionOptions[selectedCountry] || []
    : [];

  // Handle resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Get appropriate color based on user type
  const getUserTypeColor = () => {
    return selectedUserType === "retail-business" ? "#2D4CA8" : "#9F4AFF";
  };

  const getUserTypeSecondaryColor = () => {
    return selectedUserType === "retail-business" ? "#1a3a8f" : "#8c3fe6";
  };

  return (
    <div
      className="sliding-cards-section py-0 pt-5"
      style={{
        backgroundColor: "#001964",
        marginBottom: "0px",
        borderRadius: "20px",
        padding: "clamp(15px, 4vw, 30px)",
      }}
    >
      <div className="container">
        {/* Header Section - UPDATED TO MATCH LOGIN PAGE STYLES */}
        <div style={{ marginBottom: "30px", textAlign: "center" }}>
          {/* Main Welcome Title - Split into multiple elements like Login page */}
          <h2
            className="text-center mb-4"
            style={{
              fontWeight: "bold",
              fontSize: "clamp(1.2rem, 4vw, 2.2rem)",
              color: "#fff",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
              padding: "0 10px",
            }}
          >
            Welcome to TopCoin UK – Become a Participating Retail Business or
            Independent Promotional Agent
          </h2>

          <p
            className="text-center mb-4"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "clamp(0.8rem, 2.5vw, 1.1rem)",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
              padding: "0 15px",
            }}
          >
            Help businesses grow through structured advertising and customer
            loyalty activity with TopCoin UK.Participating retail businesses and
            approved independent agents may receive promotional incentives based
            on programme activity and engagement levels, in accordance with
            company terms.
          </p>

          <p
            className="text-center mb-4"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "clamp(0.8rem, 2.5vw, 1.1rem)",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
              padding: "0 15px",
            }}
          >
            Our team will guide you through the onboarding process and support
            you in getting started with TopCoin UK.
          </p>

          <p
            className="text-center mb-5"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "clamp(0.8rem, 2.5vw, 1.1rem)",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
              padding: "0 15px",
            }}
          ></p>

          {/* User Type Selection Tabs */}
          <div className="row justify-content-center mb-5">
            <div className="col-md-6 col-lg-4">
              <div
                style={{
                  display: "flex",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  borderRadius: "50px",
                  padding: "5px",
                }}
              >
                <button
                  onClick={() => handleUserTypeChange("retail-business")}
                  style={{
                    flex: 1,
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "50px",
                    backgroundColor:
                      selectedUserType === "retail-business"
                        ? "#2D4CA8"
                        : "transparent",
                    color:
                      selectedUserType === "retail-business"
                        ? "white"
                        : "rgba(255, 255, 255, 0.8)",
                    fontWeight: "600",
                    fontSize: "clamp(0.8rem, 2.5vw, 0.95rem)",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                >
                  For Retail Businesses
                </button>
                <button
                  onClick={() => handleUserTypeChange("retail-agent")}
                  style={{
                    flex: 1,
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "50px",
                    backgroundColor:
                      selectedUserType === "retail-agent"
                        ? "#9F4AFF"
                        : "transparent",
                    color:
                      selectedUserType === "retail-agent"
                        ? "white"
                        : "rgba(255, 255, 255, 0.8)",
                    fontWeight: "600",
                    fontSize: "clamp(0.8rem, 2.5vw, 0.95rem)",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                >
                  For Retail Agents
                </button>
              </div>
            </div>
          </div>

          {/* Country and Region Dropdowns  */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "clamp(12px, 3vw, 32px)",
              marginBottom: "24px",
              flexWrap: "wrap",
              justifyContent: "center",
              padding: "0 15px",
            }}
          >
            {/* Country Dropdown */}
            <div style={{ position: "relative", minWidth: "200px" }}>
              <button
                onClick={() => setIsCountryDropdownOpen(!isCountryDropdownOpen)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "8px",
                  padding: "3px 8px",
                  backgroundColor: "transparent",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  cursor: "pointer",
                  minWidth: "200px",
                  fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                  fontWeight: "500",
                  color: "#fff",
                }}
              >
                <span>
                  <FaGlobe style={{ marginRight: "8px", color: "#fff" }} />
                  {selectedCountry || "Select Country"}
                </span>
                <FaChevronDown style={{ fontSize: "12px" }} />
              </button>
              {isCountryDropdownOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    marginTop: "4px",
                    maxHeight: "300px",
                    overflowY: "auto",
                    zIndex: 1000,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                >
                  {countries.map((country) => (
                    <div
                      key={country}
                      onClick={() => handleCountryChange(country)}
                      style={{
                        padding: "10px 16px",
                        cursor: "pointer",
                        backgroundColor:
                          selectedCountry === country
                            ? "#f0f0f0"
                            : "transparent",
                        color: "#333",
                        fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#f5f5f5";
                      }}
                      onMouseLeave={(e) => {
                        if (selectedCountry !== country) {
                          e.target.style.backgroundColor = "transparent";
                        }
                      }}
                    >
                      {country}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Region Dropdown */}
            <div style={{ position: "relative", minWidth: "200px" }}>
              <button
                onClick={() => setIsRegionDropdownOpen(!isRegionDropdownOpen)}
                disabled={!selectedCountry}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "8px",
                  padding: "5px 8px",
                  backgroundColor: "transparent",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  cursor: !selectedCountry ? "not-allowed" : "pointer",
                  minWidth: "200px",
                  fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                  fontWeight: "500",
                  color: "#fff",
                  opacity: !selectedCountry ? 0.6 : 1,
                }}
              >
                <span>
                  <FaMapMarkerAlt
                    style={{ marginRight: "8px", color: "#fff" }}
                  />
                  {selectedRegion || "Select Region"}
                </span>
                <FaChevronDown style={{ fontSize: "12px" }} />
              </button>
              {isRegionDropdownOpen && currentRegions.length > 0 && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    marginTop: "4px",
                    maxHeight: "300px",
                    overflowY: "auto",
                    zIndex: 1000,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                >
                  {currentRegions.map((region) => (
                    <div
                      key={region}
                      onClick={() => handleRegionChange(region)}
                      style={{
                        padding: "10px 16px",
                        cursor: "pointer",
                        backgroundColor:
                          selectedRegion === region ? "#f0f0f0" : "transparent",
                        color: "#333",
                        fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#f5f5f5";
                      }}
                      onMouseLeave={(e) => {
                        if (selectedRegion !== region) {
                          e.target.style.backgroundColor = "transparent";
                        }
                      }}
                    >
                      {region}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "clamp(12px, 3vw, 32px)",
              marginBottom: "24px",
              flexWrap: "wrap",
              justifyContent: "center",
              padding: "0 15px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
              <a
                href="/business-senior-mini-agents"
                style={{
                  backgroundColor: "transparent",
                  color: "#ffffff",
                  padding: "8px 24px",
                  borderRadius: "4px",
                  textDecoration: "none",
                  fontWeight: "500",
                  fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                  border: "1px solid rgba(255,255,255,0.5)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.3s ease",
                  whiteSpace: "nowrap",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "rgba(255,255,255,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                }}
              >
                🌍 View All Senior & Mini Agent Network
                <FaArrowRight size={14} />
              </a>
            </div>
          </div>
        </div>

        {/* Rest of the component remains the same... */}
        {/* Find an Agent Section */}
        <div
          className="AgentLists"
          style={{
            backgroundColor: "#ebeef7",
            padding: "clamp(20px, 4vw, 30px)",
            marginLeft: "-15px",
            marginRight: "-15px",
            width: "calc(100% + 30px)",
            position: "relative",
            left: "50%",
            right: "50%",
            marginLeft: "-50vw",
            marginRight: "-50vw",
            width: "100vw",
            maxWidth: "none",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              padding: "0 15px",
            }}
          >
            {/* Find an Agent Section */}
            <div style={{ marginBottom: "40px" }}>
              <h3
                style={{
                  fontSize: "clamp(1.1rem, 3vw, 1.5rem)",
                  fontWeight: "700",
                  color: "#001964",
                  marginBottom: "8px",
                  textAlign: "center",
                }}
              >
                Find a Business Agent
              </h3>
              <p
                style={{
                  fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
                  color: "#666666",
                  marginBottom: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                }}
              >
                Search by name, ID, country, region, or town.
              </p>

              {/* Search Bar - Full width on mobile */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  marginBottom: "20px",
                  padding: isMobile ? "0 10px" : "0",
                }}
              >
                <form
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "white",
                    border: "1px solid #d0d0d0",
                    borderRadius: "32px",
                    width: "100%",
                    maxWidth: isMobile ? "100%" : "500px",
                  }}
                  onSubmit={(e) => {
                    e.preventDefault();
                    fetchSeniorAgentsWithFilters(1, {
                      searchQuery,
                      selectedCountry,
                      selectedRegion,
                      selectedTown,
                      selectedAdminArea,
                    });
                    setCurrentPage(1);
                  }}
                >
                  <span style={{ padding: "0 12px", color: "#666" }}>
                    <FaSearch size={isMobile ? 14 : 16} />
                  </span>
                  <input
                    type="text"
                    placeholder={
                      isMobile
                        ? "Search agents by name, ID, country, region, or town..."
                        : "Search agents by name, ID, country, region, or town..."
                    }
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                      flex: 1,
                      border: "none",
                      outline: "none",
                      fontSize: isMobile ? "14px" : "14px",
                      color: "#333",
                      backgroundColor: "transparent",
                      padding: isMobile ? "10px 0" : "12px 0",
                      minHeight: isMobile ? "40px" : "auto",
                    }}
                   maxLength={20} />
                  {searchQuery && (
                    <button
                      type="button"
                      onClick={() => {
                        setSearchQuery("");
                        fetchSeniorAgentsWithFilters(1, {
                          searchQuery: "",
                          selectedCountry,
                          selectedRegion,
                          selectedTown,
                          selectedAdminArea,
                        });
                        setCurrentPage(1);
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        padding: "0 8px",
                        color: "#666",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                      title="Clear search"
                    >
                      <FaTimes size={isMobile ? 14 : 16} />
                    </button>
                  )}
                  <button
                    type="submit"
                    style={{
                      backgroundColor: getUserTypeColor(),
                      color: "white",
                      border: "none",
                      borderRadius: "0 32px 32px 0",
                      padding: isMobile ? "10px 16px" : "12px 24px",
                      marginLeft: "8px",
                      fontWeight: "bold",
                      fontSize: isMobile ? "13px" : "14px",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      minHeight: isMobile ? "40px" : "auto",
                    }}
                  >
                    {isMobile ? "Search" : "Search"}
                  </button>
                </form>
              </div>

              {/* Filter Dropdowns - Stack vertically on mobile */}
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  alignItems: "center",
                  marginBottom: "16px",
                  justifyContent: "center",
                  flexDirection: isMobile ? "column" : "row",
                  padding: isMobile ? "0 10px" : "0",
                }}
              >
                {/* Country Dropdown */}
                <div
                  style={{
                    position: "relative",
                    width: isMobile ? "100%" : "auto",
                    minWidth: isMobile ? "100%" : "140px",
                    flex: isMobile ? "none" : "1 1 auto",
                    maxWidth: isMobile ? "100%" : "200px",
                  }}
                >
                  <select
                    value={selectedCountry || "United Kingdom"}
                    onChange={(e) =>
                      handleFilterChange("country", e.target.value)
                    }
                    style={{
                      width: "100%",
                      padding: isMobile
                        ? "14px 32px 5px 12px"
                        : "12px 32px 12px 12px",
                      borderRadius: "8px",
                      border: "1px solid #d0d0d0",
                      backgroundColor: "white",
                      fontSize: isMobile ? "14px" : "14px",
                      color: "black",
                      fontWeight: "500",
                      appearance: "none",
                      cursor: "pointer",
                      minHeight: isMobile ? "48px" : "auto",
                    }}
                  >
                    <option value="">Country</option>
                    {/* Include all countries from regionOptions */}
                    {Object.keys(regionOptions).map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                    {/* Add any additional countries from availableCountries that aren't in regionOptions */}
                    {availableCountries
                      .filter(
                        (country) =>
                          !Object.keys(regionOptions).includes(country),
                      )
                      .map((country) => (
                        <option key={country} value={country}>
                          {country}
                        </option>
                      ))}
                  </select>
                  <FaChevronDown
                    size={isMobile ? 16 : 14}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "black",
                      pointerEvents: "none",
                    }}
                  />
                </div>

                {/* Admin Area Dropdown */}
                <div
                  style={{
                    position: "relative",
                    width: isMobile ? "100%" : "auto",
                    minWidth: isMobile ? "100%" : "140px",
                    flex: isMobile ? "none" : "1 1 auto",
                    maxWidth: isMobile ? "100%" : "200px",
                  }}
                >
                  <select
                    value={selectedAdminArea}
                    onChange={(e) =>
                      handleFilterChange("adminArea", e.target.value)
                    }
                    style={{
                      width: "100%",
                      padding: isMobile
                        ? "14px 32px 14px 12px"
                        : "12px 32px 12px 12px",
                      borderRadius: "8px",
                      border: "1px solid #d0d0d0",
                      backgroundColor: "white",
                      fontSize: isMobile ? "14px" : "14px",
                      color: "black",
                      fontWeight: "500",
                      appearance: "none",
                      cursor: "pointer",
                      minHeight: isMobile ? "48px" : "auto",
                    }}
                  >
                    <option value="">Admin Area</option>
                    {availableAdminAreas.map((area) => (
                      <option key={area} value={area}>
                        {area}
                      </option>
                    ))}
                  </select>
                  <FaChevronDown
                    size={isMobile ? 16 : 14}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "black",
                      pointerEvents: "none",
                    }}
                  />
                </div>

                {/* Town Dropdown */}
                <div
                  style={{
                    position: "relative",
                    width: isMobile ? "100%" : "auto",
                    minWidth: isMobile ? "100%" : "140px",
                    flex: isMobile ? "none" : "1 1 auto",
                    maxWidth: isMobile ? "100%" : "200px",
                  }}
                >
                  <select
                    value={selectedTown}
                    onChange={(e) => handleFilterChange("town", e.target.value)}
                    style={{
                      width: "100%",
                      padding: isMobile
                        ? "14px 32px 14px 12px"
                        : "12px 32px 12px 12px",
                      borderRadius: "8px",
                      border: "1px solid #d0d0d0",
                      backgroundColor: "white",
                      fontSize: isMobile ? "14px" : "14px",
                      color: "black",
                      fontWeight: "500",
                      appearance: "none",
                      cursor: "pointer",
                      minHeight: isMobile ? "48px" : "auto",
                    }}
                  >
                    <option value="">Town</option>
                    {availableTowns.map((town) => (
                      <option key={town} value={town}>
                        {town}
                      </option>
                    ))}
                  </select>
                  <FaChevronDown
                    size={isMobile ? 16 : 14}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "black",
                      pointerEvents: "none",
                    }}
                  />
                </div>
              </div>

              {searchError && (
                <div
                  style={{
                    color: "#ff6b6b",
                    fontSize: isMobile ? "13px" : "14px",
                    marginTop: "8px",
                    textAlign: "center",
                    padding: "0 10px",
                  }}
                >
                  {searchError}
                </div>
              )}
            </div>

            {/* Available Senior Agents Section */}
            <div style={{ marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "4px",
                  flexWrap: "wrap",
                }}
              >
                <h3
                  style={{
                    fontSize: "clamp(1rem, 2.8vw, 1.3rem)",
                    fontWeight: "600",
                    color: "#001964",
                    margin: 0,
                  }}
                >
                  Available Senior{" "}
                  {selectedUserType === "retail-business"
                    ? "Retail Business"
                    : "Retail"}{" "}
                  Agents
                </h3>
              </div>

              <p
                style={{
                  fontSize: isMobile ? "13px" : "clamp(0.9rem, 2.5vw, 1rem)",
                  color: "#001964",
                  marginBottom: "15px",
                }}
              >
                Choose an agent to join under.
              </p>
            </div>

            {/* Agents List with Scrollbar - UPDATED TO MATCH LOGIN PAGE STYLES */}
            <div
              ref={agentsListRef}
              style={{
                maxHeight: isMobile ? "500px" : "600px",
                overflowY: "auto",
                paddingRight: isMobile ? "5px" : "10px",
                marginRight: isMobile ? "-5px" : "-10px",
                scrollbarWidth: "thin",
                scrollbarColor: getUserTypeColor() + " #e0e0e0",
              }}
              className="agents-scrollable-list"
            >
              {isLoadingAgents ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <div
                    className="spinner-border"
                    style={{ color: getUserTypeColor() }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading agents...</span>
                  </div>
                </div>
              ) : agentsError ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#ff6b6b",
                  }}
                >
                  {agentsError}
                </div>
              ) : (
                <div>
                  {filteredAgents.map((agent, index) => (
                    <div
                      key={agent.id || index}
                      style={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        padding: isMobile ? "12px" : "16px",
                        marginBottom: "12px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      }}
                      className="agent-card"
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: isMobile ? "column" : "row",
                          alignItems: isMobile ? "stretch" : "flex-start",
                          gap: isMobile ? "12px" : "16px",
                        }}
                      >
                        {/* Profile Picture - Show initials if no profile photo */}
                        <div
                          style={{
                            width: isMobile ? "40px" : "50px",
                            height: isMobile ? "40px" : "50px",
                            backgroundColor: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            overflow: "hidden",
                            marginBottom: isMobile ? "4px" : "0",
                            cursor: "pointer",
                          }}
                          onClick={() => setSelectedAgentQr(agent)}
                        >
                          <QRCode
                            value={getAgentReferralLink(agent)}
                            size={isMobile ? 40 : 50}
                            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                          />
                        </div>

                        {/* Agent Details - UPDATED TO MATCH LOGIN PAGE STRUCTURE */}
                        <div style={{ flex: 1, width: "100%" }}>
                          {/* First Row: Name with number */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "4px",
                              flexWrap: "wrap",
                              gap: "8px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                flexWrap: "wrap",
                              }}
                            >
                              <h4
                                style={{
                                  fontSize: isMobile
                                    ? "14px"
                                    : "clamp(1rem, 2.5vw, 1.1rem)",
                                  fontWeight: "600",
                                  color: "#001964",
                                  margin: 0,
                                }}
                              >
                                BS{agent.id + 99}
                              </h4>
                            </div>
                          </div>

                          {/* Second Row: Senior Agent text - Always show "Senior Agent" */}
                          <div
                            style={{
                              fontSize: isMobile
                                ? "12px"
                                : "clamp(0.85rem, 2vw, 0.95rem)",
                              color: "#666",
                              marginBottom: "0px",
                              textAlign: "left",
                            }}
                          >
                            Senior Business Ads Agent
                          </div>

                          {/* Third Row: Agents and Retail Businesses counts and buttons */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "8px",
                              flexWrap: "wrap",
                              gap: "12px",
                              flexDirection: isMobile ? "column" : "row",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                width: isMobile ? "100%" : "auto",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: isMobile
                                    ? "12px"
                                    : "clamp(0.85rem, 2vw, 0.95rem)",
                                  color: "#001964",
                                  fontWeight: "500",
                                }}
                              >
                                {agent.agents_count ?? 0}{" "}
                                {(agent.agents_count ?? 0) !== 1
                                  ? "Agents"
                                  : "Agent"}
                                {" · "}
                                {agent.retail_businesses_count ?? 0}{" "}
                                {(agent.retail_businesses_count ?? 0) !== 1
                                  ? "Retail Businesses"
                                  : "Retail Business"}
                              </span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                alignItems: "center",
                                width: isMobile ? "100%" : "auto",
                                justifyContent: isMobile
                                  ? "space-between"
                                  : "flex-end",
                              }}
                            >
                              <a
                                href={`/business-senior-mini-agents`}
                                style={{
                                  color: "#333",
                                  textDecoration: "none",
                                  fontSize: isMobile
                                    ? "12px"
                                    : "clamp(0.8rem, 2vw, 0.9rem)",
                                  fontWeight: "500",
                                  border: "1px solid #d0d0d0",
                                  padding: isMobile ? "8px 12px" : "6px 16px",
                                  borderRadius: "4px",
                                  transition: "all 0.2s ease",
                                  whiteSpace: "nowrap",
                                  flex: isMobile ? "1" : "none",
                                  textAlign: "center",
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.backgroundColor = "#f5f5f5";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.backgroundColor =
                                    "transparent";
                                }}
                              >
                                View Details
                              </a>
                              <a
                                href={getAgentReferralLink(agent)}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  backgroundColor: "#223e9a",
                                  color: "white",
                                  padding: isMobile ? "8px 12px" : "6px 16px",
                                  borderRadius: "4px",
                                  textDecoration: "none",
                                  fontSize: isMobile
                                    ? "12px"
                                    : "clamp(0.8rem, 2vw, 0.9rem)",
                                  fontWeight: "500",
                                  display: "inline-block",
                                  transition: "all 0.2s ease",
                                  whiteSpace: "nowrap",
                                  flex: isMobile ? "1" : "none",
                                  textAlign: "center",
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.backgroundColor = "#1a3a8f";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.backgroundColor = "#223e9a";
                                }}
                              >
                                Join Under
                              </a>
                            </div>
                          </div>

                          {/* Divider */}
                          <div>
                            <hr
                              style={{
                                borderColor: "#e0e0e0",
                                margin: isMobile ? "8px 0" : "12px 0",
                              }}
                            />
                          </div>

                          {/* Coverage Area - Using coverage_areas instead of region */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "8px",
                              fontSize: isMobile
                                ? "11px"
                                : "clamp(0.8rem, 2vw, 0.9rem)",
                              color: "#001964",
                              flexWrap: "wrap",
                            }}
                          >
                            <FaMapMarkerAlt
                              color={getUserTypeColor()}
                              size={isMobile ? 10 : 12}
                            />
                            <span>
                              <strong>Coverage:</strong>{" "}
                              {agent.coverage_areas?.length > 0
                                ? agent.coverage_areas.join(", ").length >
                                  (isMobile ? 30 : 50)
                                  ? `${agent.coverage_areas.join(", ").substring(0, isMobile ? 30 : 50)}...`
                                  : agent.coverage_areas.join(", ")
                                : "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {filteredAgents.length === 0 && !isLoadingAgents && (
                    <div
                      style={{
                        textAlign: "center",
                        padding: isMobile ? "30px" : "40px",
                        backgroundColor: "#ffffff",
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        color: "#666666",
                      }}
                    >
                      <p
                        style={{
                          marginBottom: "16px",
                          fontSize: isMobile ? "14px" : "14px",
                        }}
                      >
                        No agents found matching your criteria.
                      </p>
                      <button
                        onClick={() => {
                          setSearchQuery("");
                          setSelectedCountry("");
                          setSelectedRegion("");
                          setSelectedTown("");
                          setSelectedAdminArea("");
                          fetchSeniorAgentsWithFilters(1, {
                            searchQuery: "",
                            selectedCountry: "",
                            selectedRegion: "",
                            selectedTown: "",
                            selectedAdminArea: "",
                          });
                        }}
                        style={{
                          backgroundColor: "transparent",
                          color: "#4CAF50",
                          border: "1px solid #4CAF50",
                          borderRadius: "20px",
                          padding: "8px 20px",
                          fontSize: "0.95rem",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#4CAF50";
                          e.target.style.color = "white";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.color = "#4CAF50";
                        }}
                      >
                        Show All Agents
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Pagination Component */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                  gap: isMobile ? "5px" : "10px",
                  flexWrap: "wrap",
                  padding: "0 10px",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: isMobile ? "8px 12px" : "8px 16px",
                    backgroundColor:
                      currentPage === 1 ? "#cccccc" : getUserTypeColor(),
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    fontSize: isMobile ? "13px" : "clamp(0.8rem, 2vw, 0.9rem)",
                    minWidth: isMobile ? "70px" : "auto",
                  }}
                >
                  Prev
                </button>

                <span
                  style={{
                    padding: isMobile ? "8px 8px" : "8px 16px",
                    color: "#333",
                    fontSize: isMobile ? "13px" : "clamp(0.8rem, 2vw, 0.9rem)",
                  }}
                >
                  Page {currentPage} of {totalPages}
                </span>

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: isMobile ? "8px 12px" : "8px 16px",
                    backgroundColor:
                      currentPage === totalPages
                        ? "#cccccc"
                        : getUserTypeColor(),
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    fontSize: isMobile ? "13px" : "clamp(0.8rem, 2vw, 0.9rem)",
                    minWidth: isMobile ? "70px" : "auto",
                  }}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* QR Code Modal */}
      {selectedAgentQr && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={() => setSelectedAgentQr(null)}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              textAlign: "center",
              position: "relative",
              maxWidth: "90%",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedAgentQr(null)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                color: "#666",
              }}
            >
              <FaTimes />
            </button>
            <h4 style={{ marginBottom: "20px", color: "#001964", marginTop: "10px" }}>
              Join under BS{selectedAgentQr.id + 99}
            </h4>
            <div style={{ background: "white", padding: "16px", borderRadius: "8px", display: "inline-block" }}>
              <QRCode
                value={getAgentReferralLink(selectedAgentQr)}
                size={200}
              />
            </div>
            <p style={{ marginTop: "20px", color: "#666", fontSize: "14px" }}>
              Scan this QR code to join under this agent
            </p>
          </div>
        </div>
      )}

      <style>
        {`
          .agents-scrollable-list::-webkit-scrollbar {
            width: 8px;
          }
          
          .agents-scrollable-list::-webkit-scrollbar-track {
            background: #e0e0e0;
            border-radius: 10px;
          }
          
          .agents-scrollable-list::-webkit-scrollbar-thumb {
            background: ${selectedUserType === "retail-business" ? "#2D4CA8" : "#9F4AFF"};
            border-radius: 10px;
          }
          
          .agents-scrollable-list::-webkit-scrollbar-thumb:hover {
            background: ${selectedUserType === "retail-business" ? "#1a3a8f" : "#8c3fe6"};
          }
          
          @media (max-width: 768px) {
            .agents-scrollable-list {
              max-height: 500px;
            }
            
            .agent-card {
              padding: 12px !important;
            }
            
            .agent-card h4 {
              font-size: 14px !important;
            }
            
            .agent-card .btn {
              font-size: 12px !important;
              padding: 8px 12px !important;
            }
            
            select {
              font-size: 14px !important;
              min-height: 48px !important;
            }
            
            input {
              font-size: 14px !important;
            }
            
            button {
              font-size: 13px !important;
            }
          }

          /* iOS specific fixes */
          @supports (-webkit-touch-callout: none) {
            select, input, button {
              -webkit-appearance: none;
              border-radius: 8px;
            }
            
            select {
              background-image: none;
            }
            
            input[type="text"],
            select {
              font-size: 16px !important;
            }
          }

          /* Android specific fixes */
          @media (max-width: 768px) {
            select, input, button {
              touch-action: manipulation;
            }
          }
        `}
      </style>
    </div>
  );
};

function WorkWithTCUKPage(props) {
  // Senior Agents state
  const [seniorAgents, setSeniorAgents] = useState([]);
  const [filteredAgents, setFilteredAgents] = useState([]);
  const [isLoadingAgents, setIsLoadingAgents] = useState(true);
  const [agentsError, setAgentsError] = useState(null);
  const location = useLocation();
  const [isPageReady, setIsPageReady] = useState(false);

  // iOS touch handling states
  const [isTouching, setIsTouching] = useState(false);
  const [touchStartTime, setTouchStartTime] = useState(0);
  const previewRef = useRef(null);

  //search error
  const [searchError, setSearchError] = useState("");

  const [displayBusinessAgents, setDisplayBusinessAgents] = useState([]);
  const [isLoadingBusinessAgents, setIsLoadingBusinessAgents] = useState(true);
  const [businessAgentsError, setBusinessAgentsError] = useState(null);

  // Filter states
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedTown, setSelectedTown] = useState("");
  const [selectedAdminArea, setSelectedAdminArea] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // Available options for filters
  const [availableCountries, setAvailableCountries] = useState([]);
  const [availableRegions, setAvailableRegions] = useState([]);
  const [availableTowns, setAvailableTowns] = useState([]);
  const [availableAdminAreas, setAvailableAdminAreas] = useState([]);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalAgents, setTotalAgents] = useState(0);

  // State for selected user type (retail-business or retail-agent)
  const [selectedUserType, setSelectedUserType] = useState("retail-business");

  const slideIntervalRef = useRef(null);
  const searchInputRef = useRef(null);
  const hoverTimeoutRef = useRef(null);

  // Create debounced search function
  const debouncedFetchAgents = useRef(
    debounce((page, filters) => {
      fetchSeniorAgentsWithFilters(page, filters);
    }, 500),
  ).current;

  // Function to fetch senior agents from API
  const fetchSeniorAgentsWithFilters = useCallback(
    async (page = 1, filters = {}) => {
      try {
        setIsLoadingAgents(true);
        setAgentsError(null);

        // Build query parameters
        const params = new URLSearchParams();
        params.append("page", page.toString());
        params.append("per_page", "10");
        params.append("user_type", selectedUserType);

        // Add search if it has value
        if (filters.searchQuery && filters.searchQuery.trim()) {
          params.append("search", filters.searchQuery.trim());
        }

        // Add filters if they have values
        if (filters.selectedCountry && filters.selectedCountry.trim()) {
          params.append("country", filters.selectedCountry);
        }
        if (filters.selectedRegion && filters.selectedRegion.trim()) {
          params.append("region", filters.selectedRegion);
        }
        if (filters.selectedTown && filters.selectedTown.trim()) {
          params.append("town", filters.selectedTown);
        }
        if (filters.selectedAdminArea && filters.selectedAdminArea.trim()) {
          params.append("admin_area", filters.selectedAdminArea);
        }

        const queryString = params.toString();
        const url = `${API_URL}/api/public/senior-business-agents-with-mini${queryString ? "?" + queryString : ""}`;

        console.log("Fetching URL:", url);

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Received data:", data);

        if (data.success) {
          // Update filter options from response
          setAvailableCountries(data.filters?.available_countries || []);
          setAvailableRegions(data.filters?.available_regions || []);
          setAvailableTowns(data.filters?.available_towns || []);
          setAvailableAdminAreas(data.filters?.available_admin_areas || []);

          // Format agents for UI
          const colors = [
            "#2D4CA8",
            "#9F4AFF",
            "#FF6B6B",
            "#4CAF50",
            "#FF9800",
            "#9C27B0",
            "#2196F3",
            "#FF5722",
          ];

          const formattedAgents = (data.senior_agents || []).map(
            (agent, index) => {
              // Generate different referral links based on user type
              const retailBusinessLink = `${window.location.origin}/retail-business-signup?ref=${agent.agent_code}`;
              const retailAgentLink = `${window.location.origin}/retail-agent-signup?ref=${agent.agent_code}`;

              // Generate a color based on agent ID for UI consistency
              const colorIndex = agent.id
                ? agent.id % colors.length
                : index % colors.length;

              return {
                id: agent.id || index,
                user_id: agent.user_id,
                name:
                  agent.name ||
                  `${agent.first_name || ""} ${agent.last_name || ""}`.trim(),
                fullName:
                  agent.name ||
                  `${agent.first_name || ""} ${agent.last_name || ""}`.trim(),
                firstName: agent.first_name,
                lastName: agent.last_name,
                location:
                  agent.focus_countries?.[0] || agent.country || "Unknown",
                region: agent.region || agent.focus_countries?.[1] || "",
                position: agent.position || "Senior Agent",
                retailBusinessLink: retailBusinessLink,
                retailAgentLink: retailAgentLink,
                profile_photo: agent.profile_photo,
                color: colors[colorIndex],
                email: agent.email,
                phoneNumber: agent.phone_number,
                memberSince: agent.member_since,
                seniorSince: agent.senior_since,
                isActive: agent.is_verified,
                isVerified: agent.is_verified,
                agentCode: agent.agent_code,
                agent_code: agent.agent_code,
                focus_countries: agent.focus_countries || [],
                coverage_areas: agent.coverage_areas || [],
                mini_agents_count: agent.mini_agents_count || 0,
                agents_count: agent.agents_count ?? 0,
                retail_businesses_count: agent.retail_businesses_count ?? 0,
                country: agent.country,
                shortName:
                  agent.name?.split(" ")[0]?.charAt(0) +
                  ". " +
                  (agent.name?.split(" ")[1] || ""),
              };
            },
          );

          // Sort agents to ensure "TopCoin UK Business Master" appears first
          const sortedAgents = [...formattedAgents].sort((a, b) => {
            // Check if name contains "TopCoin UK Business Master" or similar variations (case insensitive)
            const aIsTopCoin =
              a.name &&
              (a.name.toLowerCase().includes("topcoin uk business master") ||
                a.name.toLowerCase().includes("topcoin business master") ||
                a.name.toLowerCase().includes("topcoin agent"));
            const bIsTopCoin =
              b.name &&
              (b.name.toLowerCase().includes("topcoin uk business master") ||
                b.name.toLowerCase().includes("topcoin business master") ||
                b.name.toLowerCase().includes("topcoin agent"));

            if (aIsTopCoin && !bIsTopCoin) return -1;
            if (!aIsTopCoin && bIsTopCoin) return 1;
            return 0;
          });

          setSeniorAgents(sortedAgents);
          setFilteredAgents(sortedAgents);

          // Update pagination
          setCurrentPage(data.pagination?.current_page || 1);
          setTotalPages(data.pagination?.last_page || 1);
          setTotalAgents(data.pagination?.total || 0);
        } else {
          throw new Error(data.message || "Failed to fetch agents");
        }
      } catch (error) {
        console.error("Failed to fetch senior agents:", error);
        setAgentsError(
          "Failed to load senior agents. Showing sample data instead.",
        );

        // Fallback data with TopCoin Agent first
        const fallbackData = [
          {
            id: 1,
            name: "TopCoin Agent",
            fullName: "TopCoin Agent",
            location: "United Kingdom",
            region: "England - City of London",
            position: "Senior Agent",
            retailBusinessLink: `${window.location.origin}/retail-business-signup?ref=TOPCOIN`,
            retailAgentLink: `${window.location.origin}/retail-agent-signup?ref=TOPCOIN`,
            profile_photo: null,
            color: "#2D4CA8",
            agentCode: "TOPCOIN",
            agent_code: "TOPCOIN",
            email: "tcukbusicharity@topcoinuk.com",
            coverage_areas: [],
            mini_agents_count: 0,
            agents_count: 0,
            retail_businesses_count: 0,
            country: "United Kingdom",
            isVerified: true,
          },
          {
            id: 2,
            name: "Nirushan Naguleswara",
            fullName: "Nirushan Naguleswara",
            location: "United Kingdom",
            region: "England - City of London",
            position: "Senior Agent",
            retailBusinessLink: `${window.location.origin}/retail-business-signup?ref=6F98AE8C`,
            retailAgentLink: `${window.location.origin}/retail-agent-signup?ref=6F98AE8C`,
            profile_photo: null,
            color: "#9F4AFF",
            agentCode: "6F98AE8C",
            agent_code: "6F98AE8C",
            email: "iam1@gma.co",
            coverage_areas: [
              "Area 3 – South London",
              "Area 4 – East London",
              "Area 28 – South East Commuter Belt-Hampshire (north & central parts)",
              "Area 29 – South Midlands & Border Consolidation",
            ],
            mini_agents_count: 0,
            agents_count: 0,
            retail_businesses_count: 0,
            country: "United Kingdom",
            isVerified: true,
          },
          {
            id: 3,
            name: "dfs sdf",
            fullName: "dfs sdf",
            location: "United Kingdom",
            region: "England - City of London",
            position: "Senior Agent",
            retailBusinessLink: `${window.location.origin}/retail-business-signup?ref=397B9C9F`,
            retailAgentLink: `${window.location.origin}/retail-agent-signup?ref=397B9C9F`,
            profile_photo: null,
            color: "#FF6B6B",
            agentCode: "397B9C9F",
            agent_code: "397B9C9F",
            email: "sdf@gb.ct",
            coverage_areas: [],
            mini_agents_count: 0,
            agents_count: 0,
            retail_businesses_count: 0,
            country: "United Kingdom",
            isVerified: true,
          },
        ];

        setSeniorAgents(fallbackData);
        setFilteredAgents(fallbackData);
        setAvailableCountries(["United Kingdom"]);
        setAvailableRegions(["England - City of London"]);
        setAvailableTowns([]);
        setAvailableAdminAreas([]);
      } finally {
        setIsLoadingAgents(false);
      }
    },
    [selectedUserType],
  );

  const fetchBusinessAgents = async () => {
    try {
      setIsLoadingBusinessAgents(true);
      setBusinessAgentsError(null);

      const response = await fetch(
        `${API_URL}/api/public/retail-businesses/agents`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Business Agents API Response:", data);

      const formattedBusinessAgents = (data.agents || []).map((agent) => ({
        id: agent.agent_id,
        fullName:
          agent.full_name ||
          `${agent.first_name || ""} ${agent.last_name || ""}`.trim(),
        location: agent.country || "Unknown",
      }));

      console.log("Formatted Business Agents:", formattedBusinessAgents);

      setDisplayBusinessAgents(formattedBusinessAgents);
    } catch (error) {
      console.error("Error fetching business agents:", error);
      setBusinessAgentsError("Failed to load business agents.");
    } finally {
      setIsLoadingBusinessAgents(false);
    }
  };

  // Initial load - fetch first page
  useEffect(() => {
    fetchSeniorAgentsWithFilters(1, {
      searchQuery: "",
      selectedCountry: "",
      selectedRegion: "",
      selectedTown: "",
      selectedAdminArea: "",
    });
  }, [selectedUserType]); // Re-fetch when user type changes

  useEffect(() => {
    fetchBusinessAgents();
  }, []);

  // Handle filter change - real-time updates
  const handleFilterChange = (filterType, value) => {
    let newSelectedCountry = selectedCountry;
    let newSelectedRegion = selectedRegion;
    let newSelectedTown = selectedTown;
    let newSelectedAdminArea = selectedAdminArea;

    switch (filterType) {
      case "country":
        newSelectedCountry = value;
        // Reset dependent filters when country changes
        newSelectedRegion = "";
        newSelectedTown = "";
        newSelectedAdminArea = "";
        setSelectedRegion("");
        setSelectedTown("");
        setSelectedAdminArea("");
        break;
      case "region":
        newSelectedRegion = value;
        // Reset town and admin area when region changes (optional)
        newSelectedTown = "";
        newSelectedAdminArea = "";
        setSelectedTown("");
        setSelectedAdminArea("");
        break;
      case "town":
        newSelectedTown = value;
        break;
      case "adminArea":
        newSelectedAdminArea = value;
        break;
      default:
        break;
    }

    setSelectedCountry(newSelectedCountry);
    setSelectedRegion(newSelectedRegion);
    setSelectedTown(newSelectedTown);
    setSelectedAdminArea(newSelectedAdminArea);
    setCurrentPage(1); // Reset to first page

    // Build filters object with only non-empty values
    const filters = {};
    if (newSelectedCountry && newSelectedCountry.trim()) {
      filters.selectedCountry = newSelectedCountry;
    }
    if (newSelectedRegion && newSelectedRegion.trim()) {
      filters.selectedRegion = newSelectedRegion;
    }
    if (newSelectedTown && newSelectedTown.trim()) {
      filters.selectedTown = newSelectedTown;
    }
    if (newSelectedAdminArea && newSelectedAdminArea.trim()) {
      filters.selectedAdminArea = newSelectedAdminArea;
    }
    if (searchQuery && searchQuery.trim()) {
      filters.searchQuery = searchQuery;
    }

    // Debounce the API call with only the active filters
    debouncedFetchAgents(1, filters);
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
      fetchSeniorAgentsWithFilters(newPage, {
        searchQuery,
        selectedCountry,
        selectedRegion,
        selectedTown,
        selectedAdminArea,
      });
    }
  };

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => {
      debouncedFetchAgents.cancel();
    };
  }, [debouncedFetchAgents]);

  // Handle user type change
  const handleUserTypeChange = async (type) => {
    setSelectedUserType(type);
    setCurrentPage(1);
    setSearchQuery("");
    setSelectedCountry("");
    setSelectedRegion("");
    setSelectedTown("");
    setSelectedAdminArea("");

    // Fetch agents with new user type
    fetchSeniorAgentsWithFilters(1, {
      searchQuery: "",
      selectedCountry: "",
      selectedRegion: "",
      selectedTown: "",
      selectedAdminArea: "",
    });
  };

  // Get the appropriate referral link based on selected user type
  const getAgentReferralLink = (agent) => {
    const baseLink =
      selectedUserType === "retail-business"
      ? agent.retailBusinessLink
      : agent.retailAgentLink;

    if (!selectedCountry?.trim()) {
      return baseLink;
    }

    try {
      const url = new URL(baseLink, window.location.origin);
      if (!url.searchParams.get("country")) {
        url.searchParams.set("country", selectedCountry.trim());
      }
      return url.toString();
    } catch (error) {
      return baseLink;
    }
  };

  // Handle card click - open appropriate referral link
  const handleCardClick = (link) => {
    window.open(link, "_blank");
  };

  // Clean up hover timeout on unmount
  useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, []);

  // Handle initial page load with hash
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPageReady(true);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  // Handle hash changes and initial load
  useEffect(() => {
    if (!isPageReady) return;

    if (location.hash) {
      const scrollTimer = setTimeout(() => {
        const elementId = location.hash.replace("#", "");
        const element = document.getElementById(elementId);
        if (element) {
          const yOffset = -80;
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 300);

      return () => clearTimeout(scrollTimer);
    }
  }, [location.hash, isPageReady]);

  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle2 pageTitle={"Work With TCUK"} pagesub={"Home"} />

          {/* Agents Section */}
          <AgentsSection
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
            selectedRegion={selectedRegion}
            setSelectedRegion={setSelectedRegion}
            selectedTown={selectedTown}
            setSelectedTown={setSelectedTown}
            selectedAdminArea={selectedAdminArea}
            setSelectedAdminArea={setSelectedAdminArea}
            availableCountries={availableCountries}
            availableRegions={availableRegions}
            availableTowns={availableTowns}
            availableAdminAreas={availableAdminAreas}
            filteredAgents={filteredAgents}
            isLoadingAgents={isLoadingAgents}
            agentsError={agentsError}
            searchError={searchError}
            fetchSeniorAgentsWithFilters={fetchSeniorAgentsWithFilters}
            handleFilterChange={handleFilterChange}
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            debouncedFetchAgents={debouncedFetchAgents}
            setCurrentPage={setCurrentPage}
            selectedUserType={selectedUserType}
            handleUserTypeChange={handleUserTypeChange}
            handleCardClick={handleCardClick}
            getAgentReferralLink={getAgentReferralLink}
          />

          {/* Add an anchor point for login section */}
          <div id="login-section"></div>

          <hr
            style={{
              padding: 0,
              margin: 0,
              height: "1px",
              backgroundColor: "gray",
            }}
          />
          <div id="business-login"></div>
          {/*Business Login*/}
          <RetailBusiness />

          <hr
            style={{
              padding: 0,
              margin: 0,
              height: "1px",
              backgroundColor: "gray",
            }}
          />
          <div id="business-agent-login"></div>
          {/*Business Agents Login*/}
          <RetailAgent />
        </main>
        <Footer />
        <Scrollbar />
      </div>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateX(-50%) translateY(-8px); }
            to { opacity: 1; transform: translateX(-50%) translateY(0); }
          }
          
          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-100% / 3));
            }
          }

          .agent-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0,0,0,0.3) !important;
          }
          
          
          .agent-preview {
            animation: fadeIn 0.2s ease;
            -webkit-tap-highlight-color: transparent;
            touch-action: manipulation;
          }
          
          .agent-preview * {
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            user-select: none;
          }
          
          /* Hide scroll buttons on very small screens */
          @media (max-width: 576px) {
            .scroll-buttons {
              display: none !important;
            }
          }

          @media (max-width: 768px) {
            .agent-preview {
              -webkit-backdrop-filter: blur(5px);
              backdrop-filter: blur(5px);
            }
          }
        `}
      </style>
    </Fragment>
  );
}

export default WorkWithTCUKPage;
